import React, { useEffect } from 'react';
import MaterialTable from 'material-table';
import { useLocation } from "react-router-dom";
import { useForm } from 'react-hook-form';

// reactstrap components
import { Row, Col, FormGroup, Input, Card, CardBody, Button } from "reactstrap";

// style
import { table_translate, table_style } from "../../../constants/MaterialTable.js";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "../../../services/acesso.js";
import ManutencaoGeradorForm from './ManutencaoGeradorForm';

//Context
import { useAuth } from '../../../context/auth';

export default function ManutencaoGeradorLista({ history }) {
  const { setLoading} = useAuth();

  const { register, getValues } = useForm({ mode: "onBlur" });
  const location = useLocation();

  const [permiteEditar, set_permiteEditar] = React.useState(false);

  const [showDetail, set_showDetail] = React.useState(false);
  const [rowEdit, set_rowEdit] = React.useState(null);
  const [list_table, set_list_table] = React.useState([]);

  const handleEdit = (rowData) => {
    api_GET('protocoloGerador/' + rowData.protocolo_Id)
      .then(result => {
        set_rowEdit(result.data);
        set_showDetail(true);
      })
      .catch(err => showMessage("Aviso", err.message, 'error', null))
      .finally(() => setLoading(false));
  }

  const handleReturn = () => {
    set_rowEdit(null);
    set_showDetail(false);
  }

  const loadList = () => {
    let data = getValues();

    if (data.cpf_cnpj.length == 0 && data.codigoCadastro.length == 0 && data.nomeResponsavel.length == 0 && data.nomeFantasia.length == 0 && data.razaoSocial.length == 0) {
      showMessage("Aviso", "Informe ao menos um dos campos!", 'error', null);
      return;
    }

    setLoading(true);
    api_GET(`protocoloGerador/GetListByCategoria/${location.state.categoria.categoria_Id}/${(data.cpf_cnpj.length == 0 ? "0" : data.cpf_cnpj)}/
      ${(data.codigoCadastro.length == 0 ? "0" : data.codigoCadastro)}/${(data.nomeResponsavel.length == 0 ? "0" : data.nomeResponsavel)}/
      ${(data.nomeFantasia.length == 0 ? "0" : data.nomeFantasia)}/${(data.razaoSocial.length == 0 ? "0" : data.razaoSocial)}`)
      .then(result => set_list_table(result.data))
      .catch(err => showMessage("Aviso", err.message, 'error', null))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    ValidaAcessoFuncionalidadeAcao("Manutencao.EditarGerador", function (result) { set_permiteEditar(result) });
  }, []);

  return (
    <>
      {!showDetail &&
        <div className="content">

          <Card className="card-stats">
            <CardBody>
              <Row className="align-items-end">
                <Col md="2">
                  <FormGroup>
                    <b><label> CNPJ/CPF</label></b>
                    <Input type="text" maxLength="14" name="cpf_cnpj" innerRef={register({ required: false })} defaultValue="" />
                  </FormGroup>
                </Col>
                <Col md="2">
                  <FormGroup>
                    <b><label> Código do Cadastro</label></b>
                    <Input type="text" maxLength="14" name="codigoCadastro" innerRef={register({ required: false })} defaultValue="" />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <b><label> Nome Responsável</label></b>
                    <Input type="text" maxLength="50" name="nomeResponsavel" innerRef={register({ required: false })} defaultValue="" />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <b><label> Nome Fantasia</label></b>
                    <Input type="text" maxLength="50" name="nomeFantasia" innerRef={register({ required: false })} defaultValue="" />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <b><label> Razão Social</label></b>
                    <Input type="text" maxLength="50" name="razaoSocial" innerRef={register({ required: false })} defaultValue="" />
                  </FormGroup>
                </Col>
                <Col>
                  <Button color="success" className="btn-mobile" type="button" onClick={loadList}><i className="fas fa-search"></i> Pesquisar</Button>
                </Col>
              </Row>
            </CardBody>
          </Card>

          {
            /* <button
              type="button"
              disabled={!permiteEditar}
              onClick={handleAdd}
              className="btn btn-secundary">
              <i className="fa fa-plus"></i>  Novo Gerador
            </button> */
          }

          <Row>
            <Col md="12">
              <MaterialTable style={{ minHeight: "auto" }}
                title={location.state.categoria.descricao}
                columns={[
                  { title: 'CNPJ / CPF', field: 'cpf_Cnpj' },
                  { title: 'Fantasia', field: 'protocoloGerador[0].nome_Fantasia' },
                  { title: 'Responsável', field: 'protocoloGerador[0].nomeResponsavel' },
                  { title: 'Status', field: 'status' }
                ]}
                data={list_table}
                isLoading={false}
                options={{
                  filtering: false,
                  exportButton: true
                }}
                actions={[
                  {
                    icon: 'edit',
                    tooltip: 'Editar Registro',
                    onClick: (event, rowData) => handleEdit(rowData)
                  }
                ]}
                localization={table_translate}
                Options={table_style}
              />
            </Col>
          </Row>
        </div>
      }
      {showDetail &&
        <ManutencaoGeradorForm item={rowEdit} handleReturn={handleReturn}></ManutencaoGeradorForm>
      }
    </>
  );
}